
import { mobileSupabase as supabase } from '@/integrations/supabase/mobile-client';
import { logger } from '@/utils/logger';

// Clear all data - for testing purposes only
export const clearAllData = async (): Promise<void> => {
  try {
    const { data: user } = await supabase.auth.getUser();
    if (user?.user) {
      await supabase.from('quotes').delete().eq('user_id', user.user.id);
      await supabase.from('milestones').delete().eq('user_id', user.user.id);
      await supabase.from('children').delete().eq('user_id', user.user.id);
    }
  } catch (error) {
    logger.error('Error in clearAllData:', error);
  }
};

// Get the user's family ID (either as owner or member)
export const getUserFamilyId = async (): Promise<string | null> => {
  try {
    const { data: userData } = await supabase.auth.getUser();
    if (!userData?.user) return null;
    
    logger.log('Getting family ID for user:', userData.user.id);
    
    // Use get_user_families function which will get all families for a user
    // This avoids the recursive policy issues
    const { data, error } = await supabase
      .rpc('get_user_families');
    
    if (error) {
      logger.error('Error fetching user families:', error);
      return null;
    }
    
    logger.log('User families data:', data);
    
    // Return the first family ID if found (users typically belong to one family)
    if (data && data.length > 0) {
      return data[0];
    }
    
    return null;
  } catch (error) {
    logger.error('Error in getUserFamilyId:', error);
    return null;
  }
};
